import { render, staticRenderFns } from "./JobMarkedDoneChatMessage.htm?vue&type=template&id=0688ff50&scoped=true&"
import script from "./JobMarkedDoneChatMessage.ts?vue&type=script&lang=js&"
export * from "./JobMarkedDoneChatMessage.ts?vue&type=script&lang=js&"
import style0 from "./JobMarkedDoneChatMessage.scss?vue&type=style&index=0&id=0688ff50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0688ff50",
  null
  
)

export default component.exports